import CryptoJS from "crypto-js";
export const encryptDataInOneLine = (data, secretKey) => {
  const encrypted = CryptoJS.AES.encrypt(data, secretKey).toString();
  const base64Encrypted = CryptoJS.enc.Base64.stringify(
    CryptoJS.enc.Utf8.parse(encrypted)
  );
  return encodeURIComponent(base64Encrypted);
};
